<template>
  <div class="allmas">
    <div class="all">
      <div class="top">
        <h4>引流折扣申请</h4>
      </div>
      <div class="center">
        <!-- 送券人（选择） -->
        <li>
          <span> 送券人：</span>
          <!-- @click="click2" -->
          <el-select v-model="sendCouponsName" placeholder="请选择送券人" filterable size="mini">
            <el-option v-for="(item, index) in namelist" :key="index" :label="item.paramValue" :value="item.paramKey">
            </el-option>
          </el-select>
          <b style="color: #7ac6ff">年</b>
        </li>
        <li>
          <span> 引流场站：</span>
          <el-select v-model="stationIds" placeholder="请选择你的引流场站" filterable @change="stationMethods">
            <el-option v-for="(item,index) in Stationlist" :key="index" :label="item.stationName" :value="item.id">
            </el-option>
          </el-select>
          <b style="color: #93d1ff">年</b>
        </li>
        <li v-if="defaultType" style="color: red; font-size: 18px">已开通</li>
        <li v-if="!defaultType">
          <span> 引流时间类型：</span>
          <el-select v-model="TimeType" placeholder="请选择你的开通时间" filterable size="mini">
            <el-option v-for="(item,index) in TimelistType" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <b style="color: #a7d9ff">年</b>
        </li>
        <li v-if="!defaultType">
          <span> 引流时间：</span>
          <el-select v-model="Time" placeholder="请选择你的开通时间" filterable size="mini">
            <el-option v-for="(item,index) in Timelist" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
          <b style="font-weight: normal; padding-left: 5px">{{ TimeName() }}</b>
        </li>
        <li>
          <span> 引流地图类型：</span>
          <el-select v-model="selected2" placeholder="请选择你的开通平台类型" filterable @change="changeMethods" size="mini">
            <el-option v-for="(item,index) in options2" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <b style="color: #d0ebff">年</b>
        </li>
        <li>
          <span> 引流平台：</span>
          <el-select v-model="moren" placeholder="请选择你的开通平台" filterable @change="changeMethods2" size="mini">
            <el-option v-for="(item,index) in options" :key="index" :label="item.paramKey" :value="item.paramKey">
            </el-option>
          </el-select>
          <b style="color: #e6f4ff">年</b>
        </li>
      </div>
    </div>
    <div class="footer">
      <button @click="okMethods" :disabled="defaultType">确认减免</button>
    </div>
    <div v-if="dialoag" class="dialoagdiv">
      <div class="content">
        <p>减免优惠码</p>
        <p>减免优惠码：{{ code }}</p>
        <p>
          <button @click="copyCode">复制分享</button>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'App',
  data() {
    return {
      defaultType: false,
      pushType: 1,
      Stationlist: [],
      namelist: [],
      selected3: window.sessionStorage.getItem('trueName'),
      dialoag2: false,
      options3: [],
      title: '请输入折扣率',
      moren: '',
      dialoag1: false,
      dialoag2: false,
      selected2: 0,
      Time: 1,
      TimeType: 0,
      stationIds: '',
      Timelist: [1, 3, 5],
      TimelistType: [
        {
          id: 0,
          name: '年',
        },
        {
          id: 1,
          name: '月',
        },
      ],
      options2: [
        {
          label: '地图平台',
          value: 0,
        },
        { label: '聚合平台', value: 1 },
      ],
      newobj: {
        money: '',
      },
      radiolist: [
        {
          checked: true,
          name: '减免折扣',
        },
        {
          checked: false,
          name: '减免金额',
        },
      ],
      sendCouponsName: null,
      selected: '',
      options: [],
      dialoag: false,
      titlelist: [],
      code: '',
      deslist: [],
      allmap: [],
      money: 0,
      currentMoney: 0,
    }
  },
  computed: {
    mapName() {
      const abc = {
        0: '地图平台',
        1: '聚合平台',
      }
      return (obj) => {
        return abc[obj] || '未知地图类型'
      }
    },
  },
  created() {
    this.$http
      .get('station-info/getAllStationInfoName', {
        params: {
          roleId: 1,
          stationMode: '0,1',
        },
      })
      .then((res) => {
        this.Stationlist = res.data.code !== 0 ? [] : res.data.data
      })
    this.$http.get(`sysConfig/getSysConfigById/101`).then((ress) => {
      const { valueName } = ress.data.data
      this.namelist = JSON.parse(valueName);
      console.log(this.namelist,163);
    })
    this.defaultMethods()
  },
  methods: {
    TimeName() {
      return this.TimeType == 0 ? '年' : '月'
    },
    stationMethods() {
      this.$http.get(`drainage-station-info/getAllPileCountByStationId/${this.stationIds}/${this.pushType}`).then((ress) => {
        this.objValue = ress.data.data
        this.defaultType = this.objValue.orNot == 1
        this.changeMethods2()
      })
    },
    defaultMethods2() {
      let result = []
      for (let i = 0; i < this.allmap.length; i += 4) {
        result.push(this.allmap.slice(i, i + 4))
      }
      return result
    },
    click2() {
      this.dialoag1 = false
    },
    changeMoney(el) {
      let abc = /^\d+(\.\d{1,2})?$/;
      console.log(el, abc.test(el), '221');
      if (!abc.test(el))
        return this.$message.error(
          el == '请输入减免金额'
            ? '请检查您的减免金额格式'
            : '请检查你的折扣率格式'
        )
    },
    Methodscurrent(el) {
      this.radiolist[0].checked = el == 0 ? this.radiolist[el].checked : false;
      this.radiolist[1].checked = el == 1 ? this.radiolist[el].checked : false;
      this.title = el == 1 ? '请输入减免金额' : '请输入折扣率'
    },
    okMethods() {
      const abc = { '高德地图': 1, '河南省平台': 2, '新电途': 3, '小桔充电': 4 };
      if (this.stationIds == '') {
        this.$message.error('请选择引流场站')
        return
      }
      let acn = {
        name: this.moren,
        drainagePlatform: abc[this.moren] || 5,
        stationId: this.stationIds * 1,
        type: this.TimeType,
        openingTime: this.Time,
        sendCouponsName: this.sendCouponsName,
      }
      if (this.money < 1) {
        this.$message.error('敬请期待')
        return
      }
      if (this.defaultType) {
        this.$message.error('场站已申请，请切换')
        return
      }
      if (this.TimeType == 0) {
        acn.openingTime = 12 * this.Time
      }
      this.$http
        .post('drainage-preferential-log/editDrainagePreferentialLog', acn)
        .then((res) => {
          this.code = res.data.data.code
          this.dialoag = res.data.code == 0
        })
    },
    defaultMethods() {
      let abc = null
      switch (this.selected2) {
        case 0:
          abc = 35
          break
        default:
          abc = 36
          break
      }
      // 引流类型
      this.$http.get(`sysConfig/getSysConfigById/${abc}`).then((res) => {
        if (res.data.code !== 0) return
        this.options = JSON.parse(res.data.data.valueName)
        this.options.forEach((item) => {
          item.paramKey = item.paramKey.split('-')[0]
        })
        this.moren = this.options[0].paramKey
      })
    },
    changeMethods() {
      this.dialoag1 = false
      this.defaultMethods()
    },
    changeMethods2(el) {
      const acn = el || '高德地图';
      let abc1 = this.options.filter((item) => item.paramKey == acn);
      console.log(abc1, '323');
      const abc = { '高德地图': 1, '河南省平台': 2, '新电途': 3, '小桔充电': 4 };
      const { paramKey } = abc1[0]
      this.pushType = abc[paramKey] || 5
      this.money = paramKey == '敬请期待' ? 0 : paramKey
      this.dialoag2 = false
    },
    click1() {
      let abc = null
      switch (this.selected2) {
        case 0:
          abc = 35
          break
        default:
          abc = 36
          break
      }
      this.dialoag2 = false
      this.$http.get(`sysConfig/getSysConfigById/${abc}`).then((res) => {
        if (res.data.code !== 0) return
        this.allmap = JSON.parse(res.data.data.valueName)
        this.deslist = res.data.data.des.split('<br>')
        this.allmap.forEach((item) => {
          this.options.push({
            name: item.paramKey.split('-')[0],
            paramValue: item.paramValue,
          })
        })
        this.dialoag1 = !this.dialoag1
      })
    },
    click2() {
      this.dialoag1 = false
      this.dialoag2 = !this.dialoag2
    },
    // 复制分享
    copyCode() {
      this.$copyText(this.code).then((res) => {
        if (res) {
          this.dialoag = false
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.allmas {
  width: 100vw;
  background: linear-gradient(to bottom, #55b6ff, #fff);
  height: 100vh;
  position: relative;
  display: flex;
  overflow: hidden;
  flex-direction: column;
}

.dialoagdiv {
  width: 100%;
  height: 100%;
  background-color: #5c5858;
  opacity: 0.9;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 99;
  overflow: hidden;
}

.dialoagdiv>.content {
  width: auto;
  height: auto;
  background-color: #fff;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.dialoagdiv>.content>p {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialoagdiv>.content>p:nth-child(1) {
  font-size: 24px;
}

.dialoagdiv>.content>p:nth-child(2) {
  margin: 0 10px;
  font-size: 16px;
}

.dialoagdiv>.content>p:nth-child(3) {
  padding: 0 5%;
}

.dialoagdiv>.content>p>button {
  text-align: center;
  padding: 10px 0;
  height: 40px;
  width: 80%;
  background-color: #55b6ff;
  color: #fff;
  border-radius: 15px;
  border: none;
  font-size: 18px;
}

.all {
  flex: 9;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.top,
.center {
  padding: 0 10%;
}

.top {
  flex: 1;
}

.top>h4 {
  font-size: 26px;
}

.center {
  flex: 9;
  display: flex;
  font-size: 20px;
  flex-direction: column;
}

.center>li {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  // margin-top: 50px;
  position: relative;
}

.center>li:nth-child(1) {
  margin-top: 10px;
}

.center>li>span {
  width: 180px;
}

.weidingyi {
  position: relative;
  width: 150px;
}

.weidingyi>span {
  position: absolute;
  right: -10%;
  top: 0.5%;
  width: 20px;
}

.postionableDiv {
  position: absolute;
  border: 1px solid #fff;
  z-index: 66;
  width: 170px;
  height: 140px;
  left: 105px;
  top: 70%;
  padding: 0 5px;
  font-size: 16px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
}

.postionableDiv>span {
  line-height: 30px;
}

.footer {
  flex: 1;
  display: flex;
  justify-content: center;
  padding: 0 10%;
  background-color: #fff;
  align-items: center;
  overflow: hidden;
}

.footer>button {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  border-radius: 15px;
  height: 40px;
  color: #fff;
  background-color: #55b6ff;
  border: none;
  font-size: 24px;
}
</style>